export default "__VITE_ASSET__5dbca181__"